"use strict";

exports.__esModule = true;
exports.makeBehaviorRelatedProps = void 0;
var _dataset = require("../../entities/dataset");
const makeBehaviorRelatedProps = (component, dataset) => {
  const behaviorRelatedProps = [];
  for (const [name, behaviorDescriptor] of Object.entries(component.connection.behaviors)) {
    var _behaviorRelatedPropS;
    const behaviorRelatedPropEntry = (_behaviorRelatedPropS = behaviorRelatedPropSetters[name]) == null ? void 0 : _behaviorRelatedPropS.call(behaviorRelatedPropSetters, behaviorDescriptor, dataset);
    if (behaviorRelatedPropEntry != null && behaviorRelatedPropEntry.length) {
      behaviorRelatedProps.push(behaviorRelatedPropEntry);
    }
  }
  return behaviorRelatedProps;
};
exports.makeBehaviorRelatedProps = makeBehaviorRelatedProps;
const behaviorRelatedPropSetters = {
  input: ({
    disabled: disabledProp
  }, dataset) => [disabledProp, _dataset.Dataset.isReadonly(dataset)],
  click: ({
    action,
    disabled: disabledProp
  }, dataset) => {
    const isEnabled = clickActionToIsEnabled[action];
    return [disabledProp, !isEnabled(dataset)];
  }
};
const clickActionToIsEnabled = {
  next: _dataset.Dataset.hasNextRecord,
  previous: _dataset.Dataset.hasPrevRecord,
  nextPage: _dataset.Dataset.hasNextPage,
  previousPage: _dataset.Dataset.hasPrevPage,
  save: dataset => _dataset.Dataset.getTotalCount(dataset) > 0 && !_dataset.Dataset.isReadonly(dataset)
};
//# sourceMappingURL=make-behavior-related-props.js.map